import type { FC, PropsWithChildren, Ref } from 'react'
import { forwardRef } from 'react'

const ProductTableList: FC<PropsWithChildren> = forwardRef((props, ref: Ref<HTMLDivElement>) => {
  const { children } = props
  return (
    // <div className="flex flex-col flex-product-list space-y-lg" ref={ref}>
    <div className="grid grid-cols-[100px_1fr_auto_minmax(140px,auto)] gap-y-4" ref={ref}>
      {children}
    </div>
  )
})
ProductTableList.displayName = 'ProductTableList'

export default ProductTableList
